<div>
    <p-toast></p-toast>
    <div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <p-dialog [(visible)]="visible" [modal]="true" [closable]="false"
                  [style]="{width:  (screenWidth<900)? '65vw' :'35vw'}">
            <app-loading [message]="loadingMessage"></app-loading>
        </p-dialog>
        <div class="flex flex-column align-items-center justify-content-center">

            <img src="assets/layout/images/southern_oracle_logo.png" alt="Sakai logo" class="mb-4 w-6rem flex-shrink-0">
            <p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [style]="{width:  (screenWidth<900)? '65vw' :'35vw'}">
                <app-loading [message]="loadingMessage"></app-loading>
            </p-dialog>
            <div
                style="border-radius:35px; padding:0.25rem; background: linear-gradient(180deg, var(--primary-blue-color) 10%, rgba(33, 150, 243, 0) 30%);">
                <div class="w-full surface-card py-4 px-1 sm:px-8 login-form-padding" style="border-radius:35px">
                    <form class="login-inputs" [formGroup]="loginForm">
                        <div class="title-container">
                            <span class="login-title">
                                Login
                            </span>
                        </div>
                        <input class="login-input" placeholder="Enter your username" formControlName="username" type="text" pInputText />
                        <p-password [toggleMask]="true" [feedback]="false" placeholder="Enter your password" formControlName="password" ></p-password>
                        <div class="buttons-container">
                            <p-button class="page-action-button" label="Clear" [text]="true" [raised]="true"
                                severity="warning"><i class="pi pi-times-circle action-button-icon"></i></p-button>
                            <p-button class="page-action-button" (click)="submitLoginForm()" [disabled]="!loginForm.valid" label="Login" [text]="true" [raised]="true"
                                severity="success"><i class="pi pi-arrow-right action-button-icon"></i></p-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
